var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { UseCase } from "../../../../hooks/useUseCase";
import { defaultFilterConditionObject, FilterCondition } from "../../models/FilterCondition";
import { ChangeFilterUseCase } from "./ChangeFilterUseCase";
import { OpenedWorkSelectDialogPayload } from "./payload/OpenedWorkSelectDialogPayload";
var OpenWorkSelectDialogUseCase = /** @class */ (function (_super) {
    __extends(OpenWorkSelectDialogUseCase, _super);
    function OpenWorkSelectDialogUseCase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OpenWorkSelectDialogUseCase.prototype.execute = function (props) {
        this.usecase(new ChangeFilterUseCase()).execute({
            filterCondition: new FilterCondition(__assign({}, defaultFilterConditionObject)),
            userId: props.userId,
        });
        this.dispatch(new OpenedWorkSelectDialogPayload({ defaultWork: props.defaultWork }));
    };
    return OpenWorkSelectDialogUseCase;
}(UseCase));
export { OpenWorkSelectDialogUseCase };
